import PropTypes from 'prop-types';
import React from 'react';

const PageTitle = ({ normal, cursive, user }) => {
  const displayName = user?.given_name || user?.firstName || 'User';
  return (
    <h1 className="page__title">
      {normal} <span className="text-cursive">{cursive ? cursive : `${displayName} 👋🏿`}</span>
    </h1>
  );
};

PageTitle.propTypes = {
  normal: PropTypes.string,
  cursive: PropTypes.string,
  user: PropTypes.object
};
export { PageTitle };
